import { z } from "zod";
import { AI_REVIEW_JOB_STATUSES, AI_REVIEW_SCOPES, PHOTO_FLAGS } from "@/lib/enums";

// The POSTs here take no body (the flag and the suggestion are in the path), so this file holds
// only what comes back.

const aiReviewJobSchema = z.object({
  id: z.string(),
  scope: z.enum(AI_REVIEW_SCOPES),
  albumId: z.string().nullable(),
  photoId: z.string().nullable(),
  status: z.enum(AI_REVIEW_JOB_STATUSES),
  total: z.number(),
  reviewed: z.number(),
  failed: z.number(),
  error: z.string().nullable(),
  createdAt: z.string(),
  finishedAt: z.string().nullable(),
});
export type AiReviewJob = z.infer<typeof aiReviewJobSchema>;

export const aiReviewJobResponseSchema = z.object({ data: aiReviewJobSchema });
export const aiReviewJobListResponseSchema = z.object({ data: z.array(aiReviewJobSchema) });

/** An album's AI state, for "Check with AI": what it can read, what it has read, and the summary. */
const albumReviewStatusSchema = z.object({
  readable: z.number(),
  reviewed: z.number(),
  hasSummary: z.boolean(),
});
export type AlbumReviewStatus = z.infer<typeof albumReviewStatusSchema>;
export const albumReviewStatusResponseSchema = z.object({ data: albumReviewStatusSchema });

/**
 * A photo's AI reading as the caller may see it. `flags` (the open ones, with their labels) is
 * PM and admin only: for anyone else the key is absent.
 */
const photoReviewViewSchema = z.object({
  description: z.string(),
  equipment: z.string().nullable(),
  tags: z.array(z.string()),
  flags: z.array(z.object({ flag: z.enum(PHOTO_FLAGS), label: z.string() })).optional(),
  reviewedAt: z.string(),
});
export type PhotoReviewView = z.infer<typeof photoReviewViewSchema>;

export const photoReviewResponseSchema = z.object({ data: photoReviewViewSchema.nullable() });
